module.exports = __webpack_public_path__ + "img/sky.ce092032.jpg";